var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewSubject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.094,
    height: 28.068,
    viewBox: "0 0 21.094 28.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_74a64c0d2c73a99e016af2ad635f447b",
    "data-name": "74a64c0d2c73a99e016af2ad635f447b",
    transform: "translate(-131.7 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65232",
    "data-name": "Path 65232",
    d: "M150.408,10H136.8a5.1,5.1,0,0,0-5.1,5.1V35.433a2.635,2.635,0,0,0,2.635,2.635h16.073a2.387,2.387,0,0,0,2.386-2.389V12.389A2.383,2.383,0,0,0,150.408,10Zm-9.214,8.226a.878.878,0,0,0-.682-.255.868.868,0,0,0-.682.255l-1.106,1.1V11.741h3.54V19.3Zm9.861,17.454a.647.647,0,0,1-.647.647H134.335a.9.9,0,0,1-.894-.894h.034v-.241a.9.9,0,0,1,.859-.653h16.721v1.14Zm0-2.878H134.335a2.664,2.664,0,0,0-.859.143v-1.87h-.034V15.1a3.354,3.354,0,0,1,3.354-3.354h.192v9.681H137a.874.874,0,0,0,1.492.616l2.019-2.019,2.019,2.019a.875.875,0,0,0,1.478-.785V11.741h6.4a.647.647,0,0,1,.647.647l0,20.412Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSubject);
export default __webpack_public_path__ + "static/media/view-subject.9b157ae0e515d6df03c6128edf57c066.svg";
export { ForwardRef as ReactComponent };